import { inject, injectable } from 'inversify';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserRepositoryInterface } from '@client/entity/current-client-user/domain/repository/current-client-user.repository';
import type { CurrentClientUser } from '@client/entity/current-client-user/domain/model/current-client-user.model';
import { ClientGameDependencyTypes } from '@client/entity/client-game/client-game.dependency-types';
import type { ClientGameRepositoryInterface } from '@client/entity/client-game/domain/repository/client-game.repository';

@injectable()
export class CurrentClientUserService {
  public constructor(
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserRepository)
    private readonly currentClientUserRepository: CurrentClientUserRepositoryInterface,
    @inject(ClientGameDependencyTypes.ClientGameRepository)
    private readonly clientGameRepository: ClientGameRepositoryInterface,
  ) {}

  public async loadCurrentClientUser(): Promise<CurrentClientUser> {
    const currentClientUser = await this.currentClientUserRepository.fetchCurrentClientUser();
    await Promise.all(
      currentClientUser.clients.map(async (client) => {
        const games = await this.clientGameRepository.fetchClientGames(client.id);
        client.setGames(games);

        return client;
      }),
    );

    return currentClientUser;
  }
}
